<div class="icon-selector-container">
  <div #triggerField class="icon-field" (click)="toggleDropdown()">
    <div class="icon-field-content">
      @if (control?.value) {
        <i class="ti ti-{{ control.value }} selected-icon" [style.color]="iconColor"></i>
      } @else {
        <span class="placeholder">{{ 'selectIcon' | translate }}</span>
      }
    </div>
    <div class="icon-field-actions">
      @if (control?.value) {
        <i class="ti ti-x clear-icon" (click)="clearIcon($event)"></i>
      }
      <i class="ti ti-chevron-down"></i>
    </div>
  </div>

  @if (showIconDropdown) {
    <div class="icon-dropdown" [ngStyle]="dropdownStyle">
      <div class="icon-search">
        <input
          type="text"
          [(ngModel)]="iconSearchTerm"
          (input)="filterIcons()"
          [placeholder]="'search' | translate"
          (click)="$event.stopPropagation()"
        />
      </div>

      <div class="icon-grid">
        @for (icon of filteredIcons; track icon) {
          <div
            class="icon-item"
            [class.selected]="control?.value === icon"
            (click)="selectIcon(icon)"
            [title]="icon"
          >
            <i class="ti ti-{{ icon }}" [style.color]="iconColor"></i>
          </div>
        }
      </div>

      @if (filteredIcons.length === 0) {
        <div class="no-results">{{ 'NoData' | translate }}</div>
      }
    </div>

    <div class="backdrop" (click)="closeDropdown()"></div>
  }
</div>
